<template>
  <div class="title-wrap">
    <span class="title-icon" :style="{borderColor: color}">
      <span class="title-icon-after" :style="{borderColor: color, backgroundColor: color}"></span>
    </span>
    <h3 :style="{color: titleColor}">{{title}}</h3>
    <span class="title-icon" :style="{borderColor: color}">
      <span class="title-icon-after" :style="{borderColor: color, backgroundColor: color}"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: ['title', 'color', 'titleColor']
}
</script>


<style lang="scss" scoped>
  .title-wrap {
    text-align: center;

    .title-icon {
      display: inline-block;
      position: relative;
      top: -5px;
      width: 14px;
      height: 14px;
      border: 1px solid #ec1c24;
      transform: rotate(45deg);

      .title-icon-after {
        content: "";
        position: absolute;
        left: 10px;
        top: -10px;
        width: 14px;
        height: 14px;
        border: 1px solid #ec1c24;
        background-color: #ec1c24;
      }
    }

    h3 {
      display: inline-block;
      position: relative;
      margin-left: 40px;
      margin-right: 26px;
      font-size: 36px;
      font-weight: 600;
    }
  }
</style>

